module.exports = __webpack_public_path__ + "img/dollar.f6612e45.png";